import { KeyAmount } from 'src/app/shared/models/interface/concretes/key-amount.interface';
import { PackageVM } from 'src/app/shared/models/interface/concretes/offer-customize-custom.interface';

export interface SummaryOption extends KeyAmount {
  id: number;
  code: string;
  metadatas: string | null;
}

export type SummaryOfferState = {
  package: PackageVM | null;
  options: SummaryOption[];
};

export const initialSummaryOfferState: SummaryOfferState = {
  package: null,
  options: [],
};
